// extracted by mini-css-extract-plugin
export default {"counter-container":"StreamWatch_counter-container__+FibO","gradient":"StreamWatch_gradient__eiuT1"};